import { gql } from "@apollo/client";
export const HelpTextsGroupQuery = gql`
    query(
        $skip: Int,
        $take: Int,
        $where: HelpTextFilterInput
        $order: [HelpTextSortInput!],
    ) {
        HelpTexts (
            skip: $skip,
            take: $take,
            where: $where
            order: $order,
        ) {
            items {
                ID
                ApplicationAreaID
                Content
                FieldName
                GroupName
                Title
            }
        }
    }
`;
export const HelpTextScreenQuery = gql`
query ($pageURL: String, $applicationAreaID: Int!) {
  screen: HelpText(PageURL: $pageURL, ApplicationAreaID: $applicationAreaID) {
    ID
    Title
    Content
    PageURL
  }
}
`;